import { createContext } from "react";
import { getAuthData } from "../utils";

export const AppContext = createContext({});

const AppProvider = ({ children }) => {
  const authData = getAuthData();
  const appConfig = {
    appName: "Four Seasons",
    appLogo: "logo.png",
  };
  const value = {
    ...authData,
    ...appConfig,
    userProfile: {
      fullName: "Seelam Sivasankar Naidu",
      photo: "",
    },
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export default AppProvider;
